import React from 'react';

import {
  QuestionEditorProps,
  QuizEditField,
} from '@/modules/corporate/modules/questions/fields/types';
import { QuestionTypeEnum } from '@/types/schema';

import Editor from '../../../components/Editor';
import EditorOptionsList from '../../../single-select/EditorOptionsList';

const MultiSelectEditField: QuizEditField = {
  Editor: (props: QuestionEditorProps) => (
    <Editor isMultiSelect EditorOptionsList={EditorOptionsList} {...props} />
  ),
  type: QuestionTypeEnum.MultiSelect,
};

export default MultiSelectEditField;
